var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.VoiceFocusAudioWorkletNode = void 0;
  class VoiceFocusAudioWorkletNode extends (typeof globalThis !== "undefined" && globalThis["AudioWorkletNode"] || class Sadness {}) {}
  exports.VoiceFocusAudioWorkletNode = VoiceFocusAudioWorkletNode;
  return exports;
}